module.exports = __webpack_public_path__ + "img/palespan-biodegradable-02.d4ca8aba.jpg";